export const SET_SHOW_MY_BOOKS = 'SET_SHOW_MY_BOOKS';
export const SET_ACTIVE_FILE_DIALOG_TAB = 'SET_ACTIVE_FILE_DIALOG_TAB';
export const USER_SETTINGS_RESET_STATE = 'USER_SETTINGS_RESET_STATE';
export const SET_IMAGE_BANK_TAB_ID_CHAIN = 'SET_IMAGE_BANK_TAB_ID_CHAIN';
